import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { parse } from 'query-string';
import {
    getFundAsGiftError,
    getFundAsGiftFetchingStatus,
    getFundAsGiftProject,
    getFundAsGiftProjectNotCreatedStatus,
} from '../../project/fund-as-gift/fund-as-gift-selectors';
import { getFundAsGiftProject as fetchFundAsGiftProject } from '../../project/fund-as-gift/fund-as-gift-actions';
import { useEffect, useMemo } from 'react';

export const useFundAsGift = () => {
    const location = useLocation();
    const params = useParams();
    const fundAsGiftCode = params.fundAsGiftCode || parse(location.search).fundAsGiftCode;
    const isFetchingFundAsGiftProject = useSelector((state) => getFundAsGiftFetchingStatus(state));
    const fundAsGiftError = useSelector((state) => getFundAsGiftError(state));
    const fundAsGiftProjectNotCreated = useSelector((state) => getFundAsGiftProjectNotCreatedStatus(state));
    const fundAsGiftProject = useSelector((state) => getFundAsGiftProject(state, fundAsGiftCode));

    const shareImageUrl = useMemo(() => {
        return `/public/images/fund-as-gift/delingsbilde.png`;
    }, []);

    return {
        fundAsGiftCode,
        fundAsGiftProjectId: fundAsGiftProject?.projectId,
        fundAsGiftProject,
        isFetchingFundAsGiftProject,
        fundAsGiftError,
        shareImageUrl,
        fundAsGiftProjectNotCreated,
    };
};

export const useUpdateFundAsGiftOnLoad = (fundAsGiftCode) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchFundAsGiftProject({ fundAsGiftCode, forceFetchFromBackend: true }));
    }, [fundAsGiftCode, dispatch]);
};
